import { z } from 'zod'

// NOTE: THIS SHOULD ONLY BE USED FOR PATH PARAMETERS (URLs)
export const KebabCaseSystemCoreDataTypeSchema = z.enum([
  'address',
  'currency',
  'department',
  'line-item-type',
  'payment-method',
  'payment-term',
  'tax-type',
  'subsidiary',
  'accounting-period',
])
export type KebabCaseSystemCoreDataType = z.infer<typeof KebabCaseSystemCoreDataTypeSchema>

const NON_OPTION_SOURCE_SYSTEM_CORE_DATA_TYPES = ['accounting-period'] as const
export const OptionSourceSystemCoreDataTypeSchema = KebabCaseSystemCoreDataTypeSchema.exclude(
  NON_OPTION_SOURCE_SYSTEM_CORE_DATA_TYPES
)
export type OptionSourceSystemCoreDataType = z.infer<typeof OptionSourceSystemCoreDataTypeSchema>

export const CoreDataEntityTypeSchema = z.enum(['custom', ...KebabCaseSystemCoreDataTypeSchema.options])
export type CoreDataEntityType = z.infer<typeof CoreDataEntityTypeSchema>

export const parseSystemCoreDataType = (value: string): KebabCaseSystemCoreDataType => {
  const result = KebabCaseSystemCoreDataTypeSchema.safeParse(value)
  if (!result.success) {
    throw new Error(`Unknown system core data entity type: ${value}`, { cause: result.error })
  }
  return result.data
}

export const isSystemCoreDataType = (value: string): value is KebabCaseSystemCoreDataType =>
  KebabCaseSystemCoreDataTypeSchema.safeParse(value).success

export const isCustomCoreDataEntity = <T extends { coreDataEntity: CoreDataEntityType; omneaCustomCoreDataId?: string }>(
  entity: T
): entity is T & { coreDataEntity: 'custom'; omneaCustomCoreDataId: string } =>
  entity.coreDataEntity === 'custom' && entity.omneaCustomCoreDataId !== undefined
